import PageProfile from "pages/ma/club";

const clubRoutes = [
  { path: "/clubs/profile/:id", exact: true, component: PageProfile },
];

export default clubRoutes;
